import { useCallback, useSyncExternalStore } from 'react';

// Which collapsible cards are closed, kept for the session like the prototype's
// `S.dashCol` (plan Phase 10: "state held per page"). Keys are page-scoped, e.g. `dash:sev`.

const closed = new Set<string>();
const listeners = new Set<() => void>();
let version = 0;

function emit(): void {
  version += 1;
  listeners.forEach((l) => l());
}

function subscribe(l: () => void): () => void {
  listeners.add(l);
  return () => listeners.delete(l);
}

/** Opens every card whose key starts with `prefix` (the detail page does it per alert). */
export function resetCollapsed(prefix: string): void {
  let changed = false;
  for (const k of [...closed]) {
    if (k.startsWith(prefix)) {
      closed.delete(k);
      changed = true;
    }
  }
  if (changed) emit();
}

export function useCollapsed(key: string): [open: boolean, toggle: () => void] {
  useSyncExternalStore(subscribe, () => version);
  const toggle = useCallback(() => {
    if (closed.has(key)) closed.delete(key);
    else closed.add(key);
    emit();
  }, [key]);
  return [!closed.has(key), toggle];
}
